export const DESIGN_LABELS = {
    "abstract-001": "Abstract 001",
    "abstract-002": "Abstract 002",
    "floral-001": "Floral 001",
    "floral-002": "Floral 002",
    "floral-003": "Floral 003",
    "floral-004": "Floral 004",
    "floral-005": "Floral 005",
    "floral-006": "Floral 006",
    "floral-007": "Floral 007",
    "floral-008": "Floral 008",
    "floral-009": "Floral 009",
    "floral-010": "Floral 010",
    "floral-011": "Floral 011",
    "floral-012": "Floral 012",
    "floral-013": "Floral 013",
    "floral-014": "Floral 014",
    "floral-015": "Floral 015",
    "floral-016": "Floral 016",
    "floral-017": "Floral 017",
    "floral-018": "Floral 018",
    "floral-019": "Floral 019",
    "floral-020": "Floral 020",
    "floral-021": "Floral 021",
    "floral-022": "Floral 022",
    "floral-023": "Floral 023",
    "floral-024": "Floral 024",
    "floral-025": "Floral 025",
    "floral-026": "Floral 026",
    "floral-027": "Floral 027",
    "floral-028": "Floral 028",
    "floral-029": "Floral 029",
    "floral-030": "Floral 030",
    "floral-031": "Floral 031",
    "floral-032": "Floral 032",
    "floral-033": "Floral 033",
    "floral-034": "Floral 034",
    "floral-035": "Floral 035",
    "floral-036": "Floral 036",

    "kdrama-001": "When Life Give You Tangerines",
    "kdrama-002": "Crash Landing On You",
    "kdrama-003": "Descendants of The Sun",
    "kdrama-004": "Can This Love Be Translated",
    "kdrama-005": "Hometown Cha-Cha-Cha",
    "kdrama-006": "Lovely Runner",
    "kdrama-007": "Start Up",
    "klasik-001": "Klasik 001",
    "klasik-002": "Klasik 002",
};

export const getDesignLabel = (designCode) => DESIGN_LABELS[designCode] ?? designCode;
